"use client";
import { useScrollPosition } from "@/hooks/use-scroll-position";
import { useNavMenuHidden } from "@/stores/navmenu.atoms";
import { mapRange } from "@talentir/shared/helpers";
import Link from "next/link";
import * as React from "react";
import { BurgerMenuMobile } from "./burger-menu-mobile";
import { Logo } from "./logo";
import { NavigationDesktop } from "./navigation-desktop";
import { NavigationMobile } from "./navigation-mobile";

import type { JSX } from "react";

const Navigation = (): JSX.Element => {
    const scrollPosition = useScrollPosition();

    const backgroundColor = React.useMemo(() => {
        let opacity = mapRange(scrollPosition, 50, 150, 0.7, 1);
        if (opacity > 1.0) {
            opacity = 1.0;
        }
        if (opacity < 0.0) {
            opacity = 0.0;
        }
        return `rgba(0, 0, 0, ${opacity})`;
    }, [scrollPosition]);

    const navbarHidden = useNavMenuHidden();

    return (
        <nav
            className="fixed top-0 z-20 w-full md:w-[calc(100vw-16px)]"
            style={{
                backgroundColor,
                transition: "background-color 1.5s",
            }}
        >
            <div className="flex h-20 items-center justify-center">
                <div className="relative flex w-full max-w-7xl items-center px-4">
                    {!navbarHidden && (
                        <div className="flex items-center md:hidden">
                            <BurgerMenuMobile />
                        </div>
                    )}

                    <Link href="https://talentir.com/home" className="w-24 no-underline">
                        <Logo className="max-h-8" />
                    </Link>

                    <div className="hidden w-full md:block">
                        <NavigationDesktop />
                    </div>
                    <div className="block w-full md:hidden">
                        <NavigationMobile />
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navigation;
